export default "__VITE_ASSET__82e374c4__"